import React, { Component } from 'react'
import FixedView from '../FixedView'
import Collapsible from 'react-collapsible'
import { checkTranslation, translate } from '../../utils/useful'
import IntractionActionsList from '../IntractionActionsList'
import importedIcons from '../inputs/icons'

export default class NotebookPage extends Component {

    state = {
        collapses: false,
        pages: [
            // { name: 'page1' },
            // { name: 'page2' },
            // { name: 'page3' },
            // { name: 'page4' },
        ]
    }

    componentDidUpdate() { }

    changeFrame = (item) => {
        this.pagesList.hideView()
    }

    switchPage = (info, extra) => {
        this.props.switchPage(info, extra)
        this.pagesList.hideView()
    }

    addNewPage=()=>{
        this.props.addNewPage()
        setTimeout(() => {
            this.pagesList.hideView()
        }, 500);
    }


    render() {
        let colors = this.props.colors
        let { list } = this.props

        // console.log(this.props.pages);

        return (
            <div>
                <button onClick={() => this.pagesList.showView()} ref={el => this.pagesNode = el} className='flexc mrd-2'>
                    <div className={'flexcc pld-3 prd-4 py-1 br-5 ' + (colors?.iconInvert ? "dark-blur-bg" : 'light-blur-bg')}>
                        <div className='flexcc mrd-1'>
                            <img className={colors?.iconInvert ? 'invert' : ''} width={18} src="/assets/icons/applets/database/frame-white.svg" />
                        </div>
                        <p className='font-size-14 ' style={{ color: colors.textColor }}>{checkTranslation(this.props.currentPage?.name) ?? translate('Pages')}</p>
                    </div>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.pagesList = el} nodeRef={this.pagesNode} xOffset={this.props.language == 'fa' ? 170 : -9} bottomOffset={27} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 px-1 py-2 shadow-3  ' >
                        <div className='p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                            {Array.isArray(this.props.pages) && this.props.pages.map((item, index) => {
                                return (
                                    <IntractionActionsList onClick={this.switchPage} language={this.props.language} data={{ title: `page ${index + 1}`, index, check: index == this.props.currentPage }} />
                                )
                            })}
                        </div>
                        <div class="pt-1" style={{ borderTop: '1px solid #eee' }}>
                            <IntractionActionsList onClick={this.addNewPage} language={this.props.language} data={{ title: '{{lang}}Create New Page', icon: importedIcons.plus }} />
                        </div>
                    </div>
                </FixedView>
            </div>
        )
    }
}
